import type {EntryPoint} from 'react-relay'

import {makeResource} from '../../../utils/makeResource'

import type {CreateProjectPageComponent} from './CreateProjectPage'

export const CreateProjectPageEntryPoint: EntryPoint<CreateProjectPageComponent> = {
  root: makeResource(
    'CreateProjectPage',
    () => import(/* webpackChunkName: "CreateProjectPage" */ './CreateProjectPage'),
  ),
  getPreloadProps: () => ({}),
}
